import React, { useState, useEffect, createRef } from 'react'
import QrReader from './components/QrReader';
import QrCreator from './components/QrCreator';
import BarCode from './components/BarCode';



function App() {
  const [mode, setMode] = useState('CREATE')

  return <div className={`w-full h-full flex flex-col justify-center items-center gap-2 p-6`}>

    <img src={`/circle-kakapo-outline.svg`} className={`w-16`} />

    <div className={`w-full max-w-xl flex flex-row justify-center gap-1`}>

      <button
        className={`
          w-full rounded font-bold py-2 px-4 text-sm
          ${mode === 'READ' ? ' bg-white ' : ' bg-lime-700 text-white'}
        `}
        onClick={() => { setMode('READ') }}>
        QR code reader
      </button>

      <button
        className={`
          w-full rounded font-bold py-2 px-4 text-sm
          ${mode === 'CREATE' ? ' bg-white ' : ' bg-lime-700 text-white'}
        `}
        onClick={() => { setMode('CREATE') }} >
        QR code creator
      </button>

      <button
        className={`
          w-full rounded font-bold py-2 px-4 text-sm
          ${mode === 'BARCODE' ? ' bg-white ' : ' bg-lime-700 text-white'}
        `}
        onClick={() => { setMode('BARCODE') }} >
        Bar code scanner
      </button>

    </div>


    <div className={`w-full max-w-xl flex flex-row justify-center gap-1 bg-white rounded p-4`}>
      {mode === 'READ' && <QrReader />}
      {mode === 'CREATE' && <QrCreator />}
      {mode === 'BARCODE' && <BarCode />}
    </div>

  </div>
}

export default App
